import { render } from "./VideoView.vue?vue&type=template&id=f3b8ea40"
import script from "./VideoView.vue?vue&type=script&lang=js"
export * from "./VideoView.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\al-mouj-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__